import React from 'react';

export default class Carousel extends React.Component {
  render() {
    return (
      <div className="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img
              className="img-flex"
              src="./images/carousel/TONEMASTER-HP-Slide_Desktop.jpg"
              alt="Slide 1"
            />
            <div className="item-info">
              <h3>Versatile. Lightweight. Legendary</h3>
              <h2>Tone Master Amplifiers</h2>
              <button className="learn-more">Learn More</button>
            </div>
          </div>
          <div className="carousel-item">
            <img
              className="img-flex"
              src="./images/carousel/Pedals-Wave-3_Time-based_HP-Slide_Desktop_4.jpg"
              alt="Slide 2"
            />
            <div className="item-info">
              <h3>Time-based Effects</h3>
              <h2>Add dimension to your tone</h2>
              <button className="learn-more">Learn More</button>
            </div>
          </div>
          <div className="carousel-item">
            <img
              className="img-flex"
              src="./images/carousel/Acuostasonic_HP-Slide_Desktop.jpg"
              alt="Slide 3"
            />
            <div className="item-info">
              <h3>Introducing the</h3>
              <h2>American Acoustasonic Telecaster</h2>
              <button className="learn-more">Learn More</button>
            </div>
          </div>
          <div className="carousel-item">
            <img
              className="img-flex"
              src="./images/carousel/Web_Eelc_American_Ultra_1105_HPS_Desktop_V4_2x.jpg"
              alt="Slide 4"
            />
            <div className="item-info">
              <h3>Never play Fender the same way again</h3>
              <h2>American Ultra Series</h2>
              <button className="learn-more">Learn More</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
